export default "__VITE_ASSET__VhoNrdm$__"